import { motion } from 'motion/react';
import styles from './QrCodes.module.css';
import { useGetParams } from 'hooks/useGetParams';

export const QrCodes = () => {
  const { qrCode1, qrCode2, qrTitle1, qrTitle2, sizeQR } = useGetParams();

  const clrBorder = {
    whatsapp: '#a0ffa4',
    telegram: '#28A5E5',
  };

  return (
    <>
      {qrCode1 && (
        <div
          className={styles.qrCode}
          style={{
            width: `${sizeQR}rem`,
            height: `${sizeQR}rem`,
          }}
        >
          <motion.img
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.64, delay: 0.12 }}
            src={qrCode1}
            alt=""
          />
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.64, delay: 0 }}
            className={styles.borderQr}
            style={{
              borderColor: clrBorder[qrTitle1],
            }}
          />
        </div>
      )}
      {qrCode2 && (
        <div
          className={styles.qrCode}
          style={{
            width: `${sizeQR}rem`,
            height: `${sizeQR}rem`,
          }}
        >
          <motion.img
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.64, delay: 1 }}
            src={qrCode2}
            alt=""
          />
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.64, delay: 0.88 }}
            className={styles.borderQr}
            style={{
              borderColor: clrBorder[qrTitle2],
            }}
          />
        </div>
      )}
    </>
  );
};
